export function categoriesQuery(params) {
    return JSON.stringify({
        query: `
            query Categories(
                $id: ID,
                $parentIds: [ID],
                $type: String,
                $allCategories: Boolean,
                $filterIconStroke: String,
                $filterIconFill: String,
                $filterIconWidth: String,
                $filterIconHeight: String,
                $filterIconExtraClasses: String,
            ) {
                categories(
                    id: $id,
                    parentIds: $parentIds,
                    type: $type,
                    allCategories: $allCategories,
                )  {
                    id
                    title
                    parentID
                    isEventCategory
                    isTrackCategory
                    filterIcon {
                        id
                        title
                        absoluteURL
                    }
                    filterIconSvg(
                        stroke: $filterIconStroke
                        fill: $filterIconFill
                        width: $filterIconWidth
                        height: $filterIconHeight
                        extraClasses: $filterIconExtraClasses
                    )
                    children {
                        id
                        title
                        parentID
                        isEventCategory
                        isTrackCategory
                        filterIconSvg(
                            stroke: $filterIconStroke
                            fill: $filterIconFill
                            width: $filterIconWidth
                            height: $filterIconHeight
                            extraClasses: $filterIconExtraClasses
                        )
                        children {
                            id
                            title
                            parentID
                            isEventCategory
                            isTrackCategory
                            filterIconSvg(
                                stroke: $filterIconStroke
                                fill: $filterIconFill
                                width: $filterIconWidth
                                height: $filterIconHeight
                                extraClasses: $filterIconExtraClasses
                            )
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
            }
        `,
        variables: params,
    });
}
